import { zIndex, headerHeight } from '@/assets/style/utils'

export const containerStyle = {
  flexDirection: 'column',
  width: '100%',

  '@fullscreen': {
    flexDirection: 'row'
  }
}
export const menuContainerStyle = {
  height: headerHeight,
  width: '100%',

  '@desktop': {
    width: '232px'
  }
}
export const headerStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  visibility: 'visible',
  zIndex: zIndex.applicationHeader,

  '@fullscreen': {
    visibility: 'hidden'
  }
}
export const contentStyle = {
  width: '100%',
  padding: '0 $4',
  marginTop: '$12',
  '@tablet': {
    width: '760px',
    padding: '0'
  },
  '@fullscreen': {
    width: '1160px',
    marginTop: '$16'
  }
}
export const titleContainerStyle = {
  alignItems: 'center',
  borderBottom: '1px solid $nonInteractiveAuxiliar',
  justifyContent: 'space-between',
  marginBottom: '$7',
  paddingBottom: '$4',
  width: '100%'
}

export const fullWidthCss = {
  width: '100%'
}

export const tagsContainerStyle = {
  flexShrink: 0
}

export const tagCss = {
  height: '24px',
  padding: '0 $2'
}
